<template>
  <video :src="this.url" controls></video>
</template>

<script>
import utils from './../js/utils'

export default {
  name: 'VideoView',
  props: {
    src: String
  },
  data () {
    return {}
  },
  computed: {
    url () {
      return utils.url(this.src)
    }
  }
}
</script>

<style lang="scss">
 video{
   max-width: 100%;
 }
</style>
